export default () => 'Privacy Policy – Conjugr8'
